import React, { useState } from 'react';
import { Table, Button, Modal, Form, InputNumber, Select, Space, message, Card, Statistic, Row, Col, Input, Flex } from 'antd';
import { PlusOutlined, MinusOutlined, ReloadOutlined } from '@ant-design/icons';

const Inventory = () => {
    const [inventory, setInventory] = useState([
        {
            id: 1,
            productId: 1,
            productName: 'Futbol Topu',
            sku: 'FB-001',
            quantity: 15,
            minStockLevel: 5,
            location: 'Ana Depo'
        },
        {
            id: 2,
            productId: 2,
            productName: 'Basketbol Topu',
            sku: 'BB-001',
            quantity: 8,
            minStockLevel: 3,
            location: 'Ana Depo'
        },
    ]);

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [modalType, setModalType] = useState('in'); // 'in' veya 'out'
    const [form] = Form.useForm();
    const [isAddProductModalVisible, setIsAddProductModalVisible] = useState(false);
    const [addProductForm] = Form.useForm();
    const [products] = useState([
        { id: 1, name: 'Futbol Topu', sku: 'FB-001' },
        { id: 2, name: 'Basketbol Topu', sku: 'BB-001' },
        { id: 3, name: 'Voleybol Topu', sku: 'VB-001' },
        { id: 4, name: 'Hentbol Topu', sku: 'HB-001' },
        { id: 5, name: 'Tenis Topu', sku: 'TB-001' }
    ]);

    const columns = [
        { title: 'Ürün Adı', dataIndex: 'productName', key: 'productName' },
        { title: 'SKU', dataIndex: 'sku', key: 'sku' },
        { title: 'Miktar', dataIndex: 'quantity', key: 'quantity' },
        { title: 'Min. Stok Seviyesi', dataIndex: 'minStockLevel', key: 'minStockLevel' },
        { title: 'Konum', dataIndex: 'location', key: 'location' },
        {
            title: 'Stok Durumu',
            key: 'stockStatus',
            render: (_, record) => {
                const status = record.quantity <= record.minStockLevel ? 'danger' : 'success';
                return <span style={{ color: status === 'danger' ? 'red' : 'green' }}>
                    {status === 'danger' ? 'Kritik Seviye' : 'Normal'}
                </span>;
            }
        },
        {
            title: 'İşlemler',
            key: 'actions',
            render: (_, record) => (
                <Space>
                    <Button
                        icon={<PlusOutlined />}
                        type="primary"
                        onClick={() => handleStockOperation('in', record)}
                    >
                        Giriş
                    </Button>
                    <Button
                        icon={<MinusOutlined />}
                        danger
                        onClick={() => handleStockOperation('out', record)}
                    >
                        Çıkış
                    </Button>
                </Space>
            ),
        },
    ];

    const handleStockOperation = (type, record) => {
        setModalType(type);
        form.setFieldsValue({
            productId: record.productId,
            quantity: 1
        });
        setIsModalVisible(true);
    };

    const handleModalOk = () => {
        form.validateFields().then(values => {
            setInventory(inventory.map(item => {
                if (item.productId === values.productId) {
                    return {
                        ...item,
                        quantity: modalType === 'in'
                            ? item.quantity + values.quantity
                            : Math.max(0, item.quantity - values.quantity)
                    };
                }
                return item;
            }));

            message.success(`Stok ${modalType === 'in' ? 'girişi' : 'çıkışı'} başarıyla kaydedildi`);
            setIsModalVisible(false);
            form.resetFields();
        });
    };

    const handleAddProduct = () => {
        addProductForm.validateFields().then(values => {
            const selectedProduct = products.find(p => p.id === values.productId);

            if (inventory.some(item => item.productId === selectedProduct.id)) {
                message.error('Bu ürün zaten envantere eklenmiş!');
                return;
            }

            const newProduct = {
                id: inventory.length + 1,
                productId: selectedProduct.id,
                productName: selectedProduct.name,
                sku: selectedProduct.sku,
                quantity: values.quantity,
                minStockLevel: values.minStockLevel,
                location: values.location
            };

            setInventory([...inventory, newProduct]);
            message.success('Yeni ürün başarıyla eklendi');
            setIsAddProductModalVisible(false);
            addProductForm.resetFields();
        }).catch(error => {
            console.error('Form validation failed:', error);
        });
    };

    const totalProducts = inventory.reduce((sum, item) => sum + item.quantity, 0);
    const lowStockItems = inventory.filter(item => item.quantity <= item.minStockLevel).length;

    return (
        <Flex vertical gap="middle" style={{ padding: { xs: 8, sm: 16, md: 24 } }}>
            <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} lg={8}>
                    <Card>
                        <Statistic
                            title="Toplam Ürün"
                            value={totalProducts}
                            prefix={<ReloadOutlined />}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} lg={8}>
                    <Card>
                        <Statistic
                            title="Kritik Stok Sayısı"
                            value={lowStockItems}
                            valueStyle={{ color: lowStockItems > 0 ? '#cf1322' : '#3f8600' }}
                        />
                    </Card>
                </Col>
            </Row>

            <Row>
                <Col xs={24} sm={24} md={12} lg={8}>
                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        style={{ width: '100%' }}
                        onClick={() => setIsAddProductModalVisible(true)}
                    >
                        Yeni Ürün Ekle
                    </Button>
                </Col>
            </Row>

            <Row>
                <Col xs={24}>
                    <div style={{ width: '100%', overflowX: 'auto' }}>
                        <Table 
                            columns={columns} 
                            dataSource={inventory} 
                            rowKey="id"
                            scroll={{ x: 'max-content' }}
                        />
                    </div>
                </Col>
            </Row>

            <Modal
                title={`Stok ${modalType === 'in' ? 'Girişi' : 'Çıkışı'}`}
                open={isModalVisible}
                onOk={handleModalOk}
                onCancel={() => {
                    setIsModalVisible(false);
                    form.resetFields();
                }}
            >
                <Form form={form} layout="vertical">
                    <Form.Item
                        name="productId"
                        hidden
                    >
                        <InputNumber />
                    </Form.Item>
                    <Form.Item
                        name="quantity"
                        label="Miktar"
                        rules={[{ required: true, message: 'Lütfen miktar girin!' }]}
                    >
                        <InputNumber min={1} style={{ width: '100%' }} />
                    </Form.Item>
                </Form>
            </Modal>

            <Modal
                title="Yeni Ürün Ekle"
                open={isAddProductModalVisible}
                onOk={handleAddProduct}
                onCancel={() => {
                    setIsAddProductModalVisible(false);
                    addProductForm.resetFields();
                }}
            >
                <Form form={addProductForm} layout="vertical">
                    <Form.Item
                        name="productId"
                        label="Ürün"
                        rules={[{ required: true, message: 'Lütfen ürün seçin!' }]}
                    >
                        <Select
                            placeholder="Ürün seçin"
                            options={products.map(product => ({
                                value: product.id,
                                label: `${product.name} (${product.sku})`
                            }))}
                        />
                    </Form.Item>
                    <Form.Item
                        name="quantity"
                        label="Başlangıç Miktarı"
                        rules={[{ required: true, message: 'Lütfen miktar girin!' }]}
                    >
                        <InputNumber min={0} style={{ width: '100%' }} />
                    </Form.Item>
                    <Form.Item
                        name="minStockLevel"
                        label="Minimum Stok Seviyesi"
                        rules={[{ required: true, message: 'Lütfen minimum stok seviyesi girin!' }]}
                    >
                        <InputNumber min={0} style={{ width: '100%' }} />
                    </Form.Item>
                    <Form.Item
                        name="location"
                        label="Konum"
                        rules={[{ required: true, message: 'Lütfen konum girin!' }]}
                    >
                        <Input placeholder="Örn: Ana Depo, A1 Rafı, vs." />
                    </Form.Item>
                </Form>
            </Modal>
        </Flex>
    );
};

export default Inventory; 